export const ensureUniqueness = (existingSlugs, desiredSlug, suffixIndex = 0) => {
  const slug = suffixIndex === 0 ? desiredSlug : `${desiredSlug}-${suffixIndex}`;

  if (!existingSlugs.includes(slug)) {
    return slug;
  }

  return ensureUniqueness(existingSlugs, desiredSlug, suffixIndex + 1);
};

// Strip any characters we don't want from the beginning and end;
// Then replace any characters we don't want with the desired delimiter.
export const format = (slug, delimiter = '-') => slug
  .replace(/(^[^a-z0-9]+|[^a-z0-9]+$)/ig, '')
  .replace(/[^a-z0-9]+/ig, delimiter)
  .toLowerCase();
